import React from "react";
import DevicePreview from "./components/DevicePreview";
import "@assets/css/DevicePreview.css";

interface HtmlTemplatePreviewProps {
  emailContent: string;
  deviceMode?: "desktop" | "tablet" | "mobile";
}

const HtmlTemplatePreview: React.FC<HtmlTemplatePreviewProps> = ({
  emailContent,
  deviceMode = "desktop",
}) => {
  // Device width configurations
  const deviceWidths = {
    desktop: "100%",
    tablet: "768px",
    mobile: "375px",
  };

  return (
    <>
      {/* Preview header to simulate browser window */}
      <div className="preview-header">
        <div className="browser-controls">
          <div className="browser-control red"></div>
          <div className="browser-control yellow"></div>
          <div className="browser-control green"></div>
        </div>
        <div className="url-bar">
          <span className="url-bar-icon">🔒</span>
          <span className="url-text">https://www.copilotly.com</span>
        </div>
        <div className="preview-device-label">
          <span style={{ color: "#64748b", fontSize: "12px" }}>
            {deviceMode.charAt(0).toUpperCase() + deviceMode.slice(1)} Preview
          </span>
        </div>
      </div>

      {/* Email content preview */}
      {deviceMode !== "desktop" ? (
        <DevicePreview emailContent={emailContent} deviceMode={deviceMode} />
      ) : (
        <div className="email-builder-preview">
          <div dangerouslySetInnerHTML={{ __html: emailContent }} />
        </div>
      )}
    </>
  );
};

export default HtmlTemplatePreview;
